import { Controller as BaseController } from '@hotwired/stimulus';

export default class extends BaseController {
  static targets = ['modal'];
  static values = { originalContent: String, open: Boolean };

  connect() {
    this.originalContentValue = this.modalTarget.innerHTML;
    if (this.openValue) {
      this.modalTarget.showModal();
    }
  }

  open() {
    this.modalTarget.showModal();
  }

  close() {
    this.modalTarget.close();
    this.resetContent();
  }

  resetContent() {
    this.modalTarget.innerHTML = this.originalContentValue;
  }

  closeAllModalsInScope() {
    const childModals = document.querySelectorAll('dialog');

    childModals.forEach((childModal) => {
      if (childModal.open) {
        childModal.close();
      }
    });
  }

  clickOutside(event) {
    if (event.target === this.modalTarget) {
      this.close(event);
    }
  }
}
